import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardText } from "mdbreact";
import picpresent1 from "../assets/procedurepresent/1.jpg";
import picpresent2 from "../assets/procedurepresent/2.jpg";
import picpresent3 from "../assets/procedurepresent/3.jpg";
import picpresent4 from "../assets/procedurepresent/4.jpg";
import picpresent5 from "../assets/procedurepresent/5.jpg";
import picpresent6 from "../assets/procedurepresent/6.jpg";
import picpresent7 from "../assets/procedurepresent/7.jpg";
import picpresent8 from "../assets/procedurepresent/8.jpg";
import picpresent9 from "../assets/procedurepresent/9.jpg";
import picpresent10 from "../assets/procedurepresent/10.jpg";
import picpresent11 from "../assets/procedurepresent/11.jpg";
import picpresent12 from "../assets/procedurepresent/12.jpg";
import MetaTags from "react-meta-tags";

export default class Procedurepresent extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (<>
            <MetaTags>
                <title>ขั้นตอนการรายงานตัวของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="ขั้นตอนการรายงานตัวของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ขั้นตอนการรายงานตัวของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBRow>
                    <MDBCol lg="3" md="1" sm="1"></MDBCol>
                    <MDBCol lg="6" md="10" sm="10">
                        <MDBCard>
                            <MDBCardBody>
                                <MDBCardText>
                                    <div className="text-center">
                                        <iframe width="100%" height="720" src="https://www.youtube.com/embed/nJeV88-XXPs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                    </div>
                                    <h4 className="card-header bg-primary text-white">ขั้นตอนการรายงานตัว</h4>
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent1} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent2} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent3} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent4} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent5} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent6} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent7} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent8} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent9} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent10} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent11} width="100%" />
                                    <img style={{ margin: "10px 0 5px 0" }} src={picpresent12} width="100%" />
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="3" md="1" sm="1"></MDBCol>
                </MDBRow>
            </MDBContainer>
        </>)
    }
}